export default __webpack_public_path__ + "img/b33e4d084de1b07c99320a74a3419624.svg";